<template>
  <v-app>
    <div>
      <div>
        <div class="pb-4 px-3 mt-4 mx-2 mx-sm-5">
          <v-layout
            style="height: 60px;background-color: var(--v-background2-base);"
            align-center
            class="ma-0 pa-0"
            d-flex
            justify-start
          >
            <div
              style="width:5px; height:100%;background-color:var(--v-secondary-base)"
              class="mr-4"
            />
            <div
              style="font-weight: bold;font-size: 18px;"
            >
              検索
            </div>
          </v-layout>
          <v-card
            class=" mt-2 mt-sm-4"
            flat
            tile
          >
            <v-card-title>検索キーワードを入力してください</v-card-title>
            <v-text-field
              v-model="query"
              filled
              background-color="background"
              solo
              single-line
              flat
              dense
              hint="検索キーワード"
              autofocus
              class="px-4"
            />
            <v-card-actions>
              <v-spacer />
              <v-btn
                tile
                :loading="loading"
                color="accent"
                @click="search"
              >
                検索開始
              </v-btn>
            </v-card-actions>

            <v-list>
              <v-list-item
                v-for="(item, index) in results"
                :key="'result_' + index"
                class="mb-4"
                :to="{name:'TextEdit', params:{novelid:encodeHash(item.novelId), text_id:encodeHash(item.id)}}"
              >
                <v-list-item-content
                  style="background-color: var(--v-background-base);"
                  class=" px-4"
                >
                  <v-list-item-title class="mb-3">
                    <div
                      class="d-flex mb-2  align-center"
                      style="font-size: 13px;font-weight: bold;"
                    >
                      <ListIcon
                        :style="`color: var(--v-accent-base);width:6px;height:7px`"
                        class="mr-1 mb-1"
                      />
                      {{ item.name }}
                    </div>
                  </v-list-item-title>
                  <p
                    style="font-size:13px;"
                    class="highlightnone"
                    v-html="item.html"
                  />
                  <div style="text-align: right;font-size:13px;">
                    最終更新： {{ item.updateDate |dayjs }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import config from "@/const";
import firebase from "firebase";
import ListIcon from "@/component/svg/ListIcon";
import dayjs from "dayjs";
import {mapState} from "vuex";

export default {
  name: "SearchPage",
  components: {
    ListIcon
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  computed: {
    ...mapState({
      results: state => state.SearchResultModule.SearchResult,
    }),
  },
  data() {
    return {
      loading: false,
      query: ""
    }
  },
  created() {
    this.query = this.$store.state.SearchResultModule.query
  },

  methods: {
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    async search() {
      this.loading = true
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      console.log("search  this.query=" + this.query)
      await this.$store.dispatch("SearchResultModule/getValue", {
        query: this.query,
        novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0]
      })

      this.loading = false

    }
  }
}
</script>

<style>
.highlightnone {
  text-decoration: none;
  /*border-color: var(--v-secondary-base);*/
  /*border-width: 1px;*/
  /*border-radius: .2em;*/
  line-height: 23px;
}

.highlight {
  text-decoration: none;
  /*border-color: var(--v-secondary-base);*/
  /*border-width: 1px;*/
  /*border-radius: .2em;*/
  /*border: 1px solid #FF0000;*/
  background-color: #d32f2f;
  color: white;
  margin-left: 4px;
  margin-right: 4px;
}
</style>